// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"419a5d54","656":"02a4a4e0","732":"3a063a13"}[chunkId] + ".chunk.js";
};